import { FaUserCircle, FaAddressBook, FaCalendarCheck } from 'react-icons/fa';
import { MdMarkEmailRead, MdMobileFriendly } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useLogoutUserQuery } from '../../redux/services/auth/logoutAPI';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";

function Dashboard({ user }) {
  const navigate = useNavigate();
  const { refetch } = useLogoutUserQuery();

  const logoutHandle = async () => {
    refetch();
    localStorage.removeItem('user');
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
    Toast.fire({ icon: 'success', title: 'You have logged out successfully' });
    navigate('/');
  };

  const stats = [
    { label: 'Profile completeness', value: '92%', detail: 'Keep your details current for faster checkout.' },
    { label: 'Active bookings', value: user?.reservations?.length || 0, detail: 'Rooms and dining reservations in your cart.' },
    { label: 'Saved favorites', value: user?.favorites?.length || 0, detail: 'Rooms and dishes you want to revisit.' },
  ];

  return (
    <section className="bg-surface py-12 sm:py-16">
      <div className="section-shell">
        <div className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="eyebrow">User dashboard</span>
            <h1 className="section-title mt-5">Manage your GoTrip experience</h1>
            <p className="section-copy">A product-focused command center for profile details, bookings, favorites, and account actions.</p>
          </div>
          <button type="button" onClick={logoutHandle} className="btn-secondary">Log out</button>
        </div>

        <div className="grid gap-6 lg:grid-cols-[18rem_1fr]">
          <aside className="premium-card bg-slate-950 p-6 text-white">
            <div className="grid place-items-center rounded-3xl bg-white/10 p-6">
              <FaUserCircle className="h-20 w-20 text-white" />
            </div>
            <h2 className="mt-6 text-xl font-black">{user?.name} {user?.family}</h2>
            <p className="mt-2 text-sm text-slate-300">Member since {user?.register_date || 'recently'}</p>
            <nav className="mt-8 space-y-2">
              <Link to={`/update_user/${user?.id}`} state={{ user }} className="block rounded-2xl px-4 py-3 text-sm font-bold text-slate-200 transition hover:bg-white/10 hover:text-white">Edit profile</Link>
              <Link to={`/change-password/${user?.id}`} state={{ user }} className="block rounded-2xl px-4 py-3 text-sm font-bold text-slate-200 transition hover:bg-white/10 hover:text-white">Change password</Link>
              <Link to="/cart" className="block rounded-2xl px-4 py-3 text-sm font-bold text-slate-200 transition hover:bg-white/10 hover:text-white">View cart</Link>
              <Link to="/favorites" className="block rounded-2xl px-4 py-3 text-sm font-bold text-slate-200 transition hover:bg-white/10 hover:text-white">Favorites</Link>
            </nav>
          </aside>

          <div className="space-y-6">
            <div className="grid gap-4 md:grid-cols-3">
              {stats.map((stat) => (
                <div key={stat.label} className="premium-card bg-white p-6">
                  <p className="text-sm font-bold uppercase tracking-wide text-muted">{stat.label}</p>
                  <p className="mt-3 text-4xl font-black tracking-tight text-ink">{stat.value}</p>
                  <p className="mt-3 text-sm leading-6 text-muted">{stat.detail}</p>
                </div>
              ))}
            </div>

            <div className="premium-card bg-white p-6">
              <h2 className="text-2xl font-black tracking-tight text-ink">User information</h2>
              <div className="mt-6 grid gap-4 md:grid-cols-2">
                <div className="rounded-3xl bg-slate-50 p-5">
                  <div className="flex items-center gap-3 text-gotrip-700"><FaUserCircle /><span className="text-sm font-black uppercase tracking-wide">Name</span></div>
                  <p className="mt-3 text-lg font-bold text-ink">{user?.name} {user?.family}</p>
                </div>
                <div className="rounded-3xl bg-slate-50 p-5">
                  <div className="flex items-center gap-3 text-gotrip-700"><MdMarkEmailRead /><span className="text-sm font-black uppercase tracking-wide">Email</span></div>
                  <p className="mt-3 text-lg font-bold text-ink">{user?.email}</p>
                </div>
                <div className="rounded-3xl bg-slate-50 p-5">
                  <div className="flex items-center gap-3 text-gotrip-700"><MdMobileFriendly /><span className="text-sm font-black uppercase tracking-wide">Mobile</span></div>
                  <p className="mt-3 text-lg font-bold text-ink">{user?.mobile_number}</p>
                </div>
                <div className="rounded-3xl bg-slate-50 p-5">
                  <div className="flex items-center gap-3 text-gotrip-700"><FaCalendarCheck /><span className="text-sm font-black uppercase tracking-wide">Registered</span></div>
                  <p className="mt-3 text-lg font-bold text-ink">{user?.register_date}</p>
                </div>
                <div className="rounded-3xl bg-slate-50 p-5 md:col-span-2">
                  <div className="flex items-center gap-3 text-gotrip-700"><FaAddressBook /><span className="text-sm font-black uppercase tracking-wide">Address</span></div>
                  <p className="mt-3 text-lg font-bold leading-7 text-ink">{user?.address}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
